import { Box, Typography } from '@mui/material';
import TableRowExport from 'component/Pdf/TableRowExport';
import TableCustom from 'component/Table/TableCustom';
import TableRowCommon from 'component/Table/TableRowCommon';
import { ExportProps } from "features/report/report-constants";
import * as UseStyled from 'features/report/useStyled';
import _ from 'lodash';
import moment from 'moment';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { numberFormat, toBuddhistYear } from "utils/app.utils";

import { UseSnCode } from 'utils/useSnCode';
export interface FcComponent {
    filter: any
    page: number
    pageLimit: number
    rowCount: number
    sortBy: string
    sortType: string
    data: any
    onRequestSort: (sortBy: string, sortType: string) => void
    handleChangeRowsPerPage: (val: any) => void
    handleChangePage: (val: any) => void
    componentRef: any
    exportData: any
}

export default function TreatmentCourseList(props: FcComponent) {
    const { t } = useTranslation()

    const [snType, setSnType] = useState(false);

    const handleSnCode = useCallback(() => {
        const fetchData = async () => {
            const sn = await UseSnCode();
            setSnType(sn);
        };

        fetchData();

    }, [snType]);
    useEffect(() => {
        handleSnCode()
    }, [])
    const headCells = [
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.TREATMENT_COURES.#NO', align: 'center', class: 'text-nowrap' },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.TREATMENT_COURES.DATE_TINE', align: 'left', class: 'text-nowrap' },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.TREATMENT_COURES.CN', align: 'left', class: 'text-nowrap' },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.TREATMENT_COURES.SN_CODE', align: 'left', class: 'text-nowrap' },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.TREATMENT_COURES.FULL_NAME', align: 'left', class: 'text-nowrap' },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.TREATMENT_COURES.COURES_NAME', align: 'left', class: 'text-nowrap' },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.TREATMENT_COURES.PRICE', align: 'center', class: 'text-nowrap' },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.TREATMENT_COURES.TOTAL', align: 'center', class: 'text-nowrap' },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.TREATMENT_COURES.AMOUNT_USED', align: 'left', class: 'text-nowrap' },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.TREATMENT_COURES.BALANCE', align: 'center', class: 'text-nowrap' }

    ]
    if (!snType) {
        headCells.splice(3, 1)
    }
    const renderData = (data: any, no: number, exportData: boolean) => {
        const num = exportData === true ? no + 1 : props.page * props.pageLimit - props.pageLimit + no + 1

        const objRenderData = {
            key: num.toString(),
            id: no.toString(),
            obj: data,
            columns: [
                { option: 'TEXT', align: 'center', label: num },
                { option: 'TEXT', align: 'left', label: data.updatedAt ? toBuddhistYear(moment(data.updatedAt), 'DD/MM/YYYY HH:mm น.') : t(`REPORT.VALUE.PATIENT.BLOOD_TYPE.NOT_SPECIFIED`), class: 'text-nowrap' },
                { option: 'TEXT', align: 'left', label: data.cnNumber ?? '-' },
                { option: 'TEXT', align: 'left', label: data.snCode ?? '-' },
                { option: 'TEXT', align: 'left', label: data.fullName ?? '-', class: 'text-nowrap' },
                { option: 'TEXT', align: 'left', label: data.itemName, class: 'text-nowrap ' },
                { option: 'PRICE', align: 'right', label: data.price, class: 'text-nowrap' },
                { option: 'TEXT', align: 'center', label: data.sum ?? '-', class: 'text-nowrap' },
                { option: 'TEXT', align: 'center', label: data.used ?? '-', class: 'text-nowrap' },
                { option: 'TEXT', align: 'center', label: data.balance ?? '-', class: 'text-nowrap' }
            ]
        }
        if (!snType) {
            objRenderData.columns.splice(3, 1)
        }
        return (
            <>
                {exportData === true && <TableRowExport {...objRenderData} /> ||
                    <TableRowCommon  {...objRenderData} />
                }
            </>
        )
    }

    return (
        <>
            <div className="print-show-disable">
                <UseStyled.ResponsiveReportTable>
                    <TableCustom
                        page={props.page}
                        pageLimit={props.pageLimit}
                        sortType={props.sortType}
                        sortBy={props.sortBy}
                        rowCount={props.rowCount}
                        onSort={props.onRequestSort}
                        setPageLimit={props.handleChangeRowsPerPage}
                        setPage={props.handleChangePage}
                        headCells={headCells}
                        rowsData={
                            _.map(props.data, (d: any, index: number) => {
                                return renderData(d, index, false)
                            })
                        }
                        customScroll
                    />
                </UseStyled.ResponsiveReportTable >
            </div>

            <Box
                id="print-table-container"
                ref={props.componentRef}
            >
                <Typography fontSize="14px" fontWeight={400}>{t('REPORT.REPORT_NAME.TREATMENT_COURES')}</Typography>
                <Box display='flex' flexDirection="row" alignItems="center" gap="16px">
                    <Typography fontSize="10px" fontWeight={400}>{t('REPORT.FILTER.BRANCH')}: {props.filter.branch}</Typography>
                    <Typography fontSize="10px" fontWeight={400}>{t('REPORT.FILTER.COURSE_NAME')}: {props.filter?.courseType}</Typography>
                    <Typography fontSize="10px" fontWeight={400}>{t('REPORT.FILTER.DATE_START')}: {props.filter.rangeDate[0] ? toBuddhistYear(moment(props.filter.rangeDate[0]), 'DD/MM/YYYY') : '-'}</Typography>
                    <Typography fontSize="10px" fontWeight={400}>{t('REPORT.FILTER.DATE_END')}: {props.filter.rangeDate[1] ? toBuddhistYear(moment(props.filter.rangeDate[1]), 'DD/MM/YYYY') : '-'}</Typography>
                </Box>

                <table style={{ width: '100%', border: '1px solid black', borderCollapse: 'collapse', marginTop: '16px' }}>
                    <thead>
                        <tr style={{ textAlign: 'center', fontSize: '9.5px', fontWeight: 700 }}>
                            <th style={{ borderBottom: '1px solid black' }}>{t('REPORT.TABLE.TREATMENT_COURES.#NO')}</th>
                            <th style={{ borderBottom: '1px solid black', textAlign: 'center' }}>{t('REPORT.TABLE.TREATMENT_COURES.DATE_TINE')}</th>
                            <th style={{ borderBottom: '1px solid black', textAlign: 'center' }}>{t('REPORT.TABLE.TREATMENT_COURES.CN')}</th>
                            {snType && <th style={{ borderBottom: '1px solid black', textAlign: 'center' }}>{t('REPORT.TABLE.TREATMENT_COURES.SN_CODE')}</th>}
                            <th style={{ borderBottom: '1px solid black', textAlign: 'left' }}>{t('REPORT.TABLE.TREATMENT_COURES.FULL_NAME')}</th>
                            <th style={{ borderBottom: '1px solid black', textAlign: 'left' }}>{t('REPORT.TABLE.TREATMENT_COURES.COURES_NAME')}</th>
                            <th style={{ borderBottom: '1px solid black', textAlign: 'center' }}>{t('REPORT.TABLE.TREATMENT_COURES.PRICE')}</th>
                            <th style={{ borderBottom: '1px solid black', textAlign: 'center' }}>{t('REPORT.TABLE.TREATMENT_COURES.TOTAL')}</th>
                            <th style={{ borderBottom: '1px solid black', textAlign: 'center' }}>{t('REPORT.TABLE.TREATMENT_COURES.AMOUNT_USED')}</th>
                            <th style={{ borderBottom: '1px solid black', textAlign: 'center' }}>{t('REPORT.TABLE.TREATMENT_COURES.BALANCE')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.exportData?.map((data: any, index: number) => (
                            <tr key={index}>
                                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'top', width: '50px' }}>{index + 1}</td>
                                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'top', width: '100px' }}>{data.updatedAt ? toBuddhistYear(moment(data.updatedAt), 'DD/MM/YYYY HH:mm น.') : '-'}</td>
                                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'top', width: '85px' }}>{data.cnNumber}</td>
                                {snType && <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'top', width: '85px' }}>{data.snCode}</td>}
                                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'top' }}>{data.fullName}</td>
                                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'top' }}>{data.itemName}</td>
                                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'top', width: '100px' }}>{numberFormat(data.price)}</td>
                                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'top', width: '85px' }}>{data.sum}</td>
                                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'top', width: '85px' }}>{data.used}</td>
                                <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'top', width: '85px' }}>{data.balance}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </Box>
            {/* <div className="print-show" ref={props.componentRef}>
                <PatientExport
                    header={
                        <UseStyled.Styles className="pt-3">
                            <table style={{ border: 'none', borderCollapse: 'collapse' }}>
                                <tr>
                                    <td style={{ border: 'none', textAlign: 'left', fontSize: '14px' }}>
                                        {t(`REPORT.REPORT_NAME.TREATMENT_COURES`)}

                                    </td>
                                </tr>
                                <TableSortLabel>
                                    <td style={{ border: 'none', fontSize: '12px' }}>{t('REPORT.FILTER.BRANCH')}: </td>
                                    <td style={{ border: 'none', fontSize: '12px' }}>{props.filter.branch}</td>
                                </TableSortLabel>
                                <TableSortLabel>
                                    <td style={{ border: 'none', fontSize: '12px' }}>{t('REPORT.FILTER.COURSE_NAME')}: </td>
                                    <td style={{ border: 'none', fontSize: '12px' }}>{props.filter.courseType}</td>
                                </TableSortLabel>
                                <TableSortLabel>
                                    <td style={{ border: 'none', fontSize: '12px' }}>{t('REPORT.FILTER.DATE_START')}: </td>
                                    <td style={{ border: 'none', fontSize: '12px' }}>{props.filter.rangeDate[0] ? toBuddhistYear(moment(props.filter.rangeDate[0]), 'DD/MM/YYYY') : '-'}    </td>
                                </TableSortLabel>
                                <TableSortLabel>
                                    <td style={{ border: 'none', fontSize: '12px' }}>{t('REPORT.FILTER.DATE_END')}: </td>
                                    <td style={{ border: 'none', fontSize: '12px' }}>{props.filter.rangeDate[0] ? toBuddhistYear(moment(props.filter.rangeDate[1]), 'DD/MM/YYYY') : '-'} </td>
                                </TableSortLabel>

                            </table>
                        </UseStyled.Styles>
                    }
                    headCells={headCells}
                    rowsData={
                        _.map(props.exportData, (d: any, index: number) => {
                            return renderData(d, index, true)
                        })
                    } />
            </div > */}
        </>

    )
}

export function PatientExport(props: ExportProps) {
    const { t } = useTranslation()
    const head = props.headCells
    const headCells = head.filter((headCell: any) => headCell.id !== 'action')
    const { header } = props
    return (
        <UseStyled.Styles className="pt-3">
            {header}
            <table style={{ tableLayout: 'fixed', borderCollapse: 'collapse', minWidth: '100%', maxWidth: '100%' }}>
                <thead>
                    <tr>
                        {_.map(headCells, (val: any, index: number) => {
                            return (
                                < td style={{ textAlign: val.align, fontSize: 10, fontWeight: 500 }}> {t(val.labelKey)}</td>
                            )
                        })}
                    </tr>
                </thead>
                <tbody >
                    {props.rowsData}
                    {!props.rowsData.length && (
                        <td colSpan={headCells.length} style={{ fontSize: 10, }}>
                            {t('REPORT.TITLE.NO_DATA')}
                        </td>
                    )}
                </tbody>
            </table>
        </UseStyled.Styles >
    )
}